import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { A, svgSprite } from '../../../../hybrid/wrappers';
import { contactImg } from '../../initData';
import Slider from 'react-slick';
import SocialWebButton from '../SocialWebButton/SocialWebButton';
import css from './modal-social.module.scss';
import classNames from 'classnames';
import CopyToClipboard from 'react-copy-to-clipboard';
import UserContext from '../../../../common/utils/getContext';
import { useClickAway } from '@uidotdev/usehooks';
import { t } from '../../../../common/components/T';
import { usePopper } from 'react-popper';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';

const contactInfo = [
    {
        link: 'mailto:',
        type: 'email'
    },
    {
        link: 'tel:',
        type: 'phone'
    },
    {
        link: 'https://www.facebook.com/',
        type: 'facebook'
    },
    {
        link: 'https://instagram.com/',
        type: 'instagram'
    },
    // {
    //     link: 'https://instagram.com/',
    //     type: 'vk'
    // },
    {
        link: 'https://t.me/',
        type: 'telegram'
    },
    {
        link: 'https://api.whatsapp.com/send?phone=',
        type: 'whatsapp'
    },
    {
        link: 'https://twitter.com/',
        type: 'twitter'
    },
    {
        link: 'viber://chat?number=',
        type: 'viber'
    }
];
const socialGenerator = (item) => {
    if (!item) return [];
    let arrSocial = [];
    contactInfo.map((contact) => {
        arrSocial.push({
            name: contact.type,
            link: contact.link + item[contact.type],
            text: item[contact.type],
            active: !!item[contact.type]
        });
    });
    return arrSocial;
};

const ModalSocial = ({
    setPopperElement,
    styles,
    attributes,
    position,
    referenceElement,
    setAlertData,
    setArrowElement,
    trans,
    idx
}) => {
    const isMobileSmall = useWindowDimensions() < 360;
    const isMobileMiddle = useWindowDimensions() < 560;

    return (
        <div ref={setPopperElement} style={styles.popper} {...attributes.popper}>
            <div
                className={css.socialItemChild}
                style={{
                    ...(position === 2 ? { bottom: '10px' } : { top: '46px' }),
                    ...(isMobileSmall
                        ? idx === 0
                            ? { right: '-103px' }
                            : idx === 7
                            ? { right: '-51px' }
                            : {}
                        : isMobileMiddle
                        ? idx === 7
                            ? { right: '-64px' }
                            : idx === 0
                            ? { right: '-91px' }
                            : {}
                        : {})
                }}
            >
                <div
                    style={{
                        ...(position === 2 ? { bottom: '-8px' } : { top: '-8px' }),
                        ...(isMobileSmall
                            ? idx === 0
                                ? { right: '77px' }
                                : idx === 7
                                ? { right: '26px' }
                                : {}
                            : isMobileMiddle
                            ? idx === 7
                                ? { right: '42px' }
                                : idx === 0
                                ? { right: '64px' }
                                : {}
                            : {})
                    }}
                    className={css.socialItemChildSymbol}
                ></div>
                <A href={referenceElement.link} target={'_blank'} title=''>
                    <div className={css.socialList1}>{t('contact_open', 'Открыть', 'widget', trans, 'userModal')}</div>
                </A>
                <div className={css.socialItemChildLine}></div>
                <div>
                    <CopyToClipboard
                        text={referenceElement.link}
                        onCopy={() =>
                            setAlertData({
                                type: 'success',
                                cont: t('CopyReferalLink-success', 'Скопировано в буфер обмена', 'widget', trans, 'userModal')
                            })
                        }
                    >
                        <div className={css.socialList2}>{t('contact_copy', 'Скопировать', 'widget', trans, 'userModal')}</div>
                    </CopyToClipboard>
                </div>
            </div>
            <div ref={setArrowElement} style={styles.arrow} />
        </div>
    );
};

const Social = ({ links, id, position, trans }) => {
    const { setAlertData } = useContext(UserContext);

    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const [arrowElement, setArrowElement] = useState(null);

    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        modifiers: [{ name: 'arrow', options: { element: arrowElement } }]
    });

    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 8,
        slidesToScroll: 1,
        nextArrow: <SocialWebButton type='next' />,
        prevArrow: <SocialWebButton type='prev' />,
        initialSlide: 0
    };

    const items = links && socialGenerator(links);

    const openModalOfContact = (item) => {
        setReferenceElement((pre) => (pre?.name === item?.name ? {} : item));
    };

    const ref = useClickAway(() => {
        setReferenceElement(false);
    });

    if (!items || (!items?.length && !trans)) return null;

    return (
        <div ref={ref} id={`SocialportalDropdown_${id}`} className={css.socialBlock}>
            {items.length < 9 ? (
                <div className={classNames(css.socialWrap, items.length < 3 ? css.JCS : '')}>
                    {items.map((item, idx) => {
                        return (
                            <div
                                className={classNames(css.socialItem, item?.active && css.socialItemHover)}
                                key={`socialItem${idx}`}
                                onClick={() => item?.active && openModalOfContact(item)}
                                ref={setReferenceElement}
                            >
                                {svgSprite(contactImg(item.name), {
                                    className: classNames(
                                        css.contactIcon,
                                        item?.active && css?.contactIconHover,
                                        item.name === referenceElement?.name && item?.active ? css.socialItemActive : ''
                                    ),
                                    notActive: !item?.active
                                })}
                                {item.name === referenceElement?.name && (
                                    <ModalSocial
                                        setPopperElement={setPopperElement}
                                        styles={styles}
                                        attributes={attributes}
                                        position={position}
                                        referenceElement={referenceElement}
                                        setAlertData={setAlertData}
                                        setArrowElement={setArrowElement}
                                        trans={trans}
                                        idx={idx}
                                    />
                                )}
                            </div>
                        );
                    })}
                </div>
            ) : (
                <Slider {...settings}>
                    {items.map((item, idx) => {
                        return (
                            <div
                                className={css.socialItem}
                                key={`socialItem${idx}`}
                                onClick={() => item?.active && openModalOfContact(item)}
                                ref={setReferenceElement}
                            >
                                {svgSprite(contactImg(item.name), {
                                    className: css.contactIcon,
                                    notActive: !item?.active
                                })}
                                {item.name === referenceElement?.name && (
                                    <ModalSocial
                                        setPopperElement={setPopperElement}
                                        styles={styles}
                                        attributes={attributes}
                                        position={position}
                                        referenceElement={referenceElement}
                                        setAlertData={setAlertData}
                                        setArrowElement={setArrowElement}
                                        trans={trans}
                                    />
                                )}
                            </div>
                        );
                    })}
                </Slider>
            )}
        </div>
    );
};
Social.propTypes = { links: PropTypes.array };
export default Social;
